import { CenteredDiv } from '../decorated-elements';
import React from 'react';
import { l10n } from '../with-app-root/i18n/i18nUtil';

const FetchError = () => {
  return (
    <CenteredDiv>
      <clr-icon
        size="24"
        shape="error-standard"
        class="is-solid is-error text-icon"
      />
      <span>{l10n('components.preCheck.preCheckStateFetchError')}</span>
    </CenteredDiv>
  );
};

export default FetchError;
